export default __webpack_public_path__ + "static/media/games-rebate-ico.da40e48b.svg";